import { JSX } from "@emotion/react/jsx-runtime";
import { ReactNode } from "react";
import { styled, Typography } from "@mui/material";
import { DynamicContentText } from "../DynamicContentComponent";

/*const StyledHeader = styled(Typography)(({ theme }) => ({
  width: "100%",
  //height: 120,
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'left',
}));*/

export const DynamicTextHeader = ({ text, childElements }: DynamicContentText): JSX.Element => {
    return <Typography variant="h1" align="left">
      {text}
      {childElements || ''}
    </Typography>
}